"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_uid_1 = require("react-uid");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_router_dom_1 = require("react-router-dom");
const material_1 = require("@mui/material");
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const services_1 = require("../../../common/services");
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const BackButton_1 = __importDefault(require("../Header/BackButton"));
const BrandVenuesWrapper = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  padding: 64px 16px 16px 16px;
  overflow-x: scroll;
  background: #fff;

  .header {
    position: fixed;
    background-color: #092a5e;
    box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 75%);
    transition:
      background 0.2s linear,
      box-shadow 0.2s linear;
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-shrink: 0;
    z-index: 1100;
    top: 0;
    left: auto;
    right: 0;
    min-height: 64px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }

  .MuiSvgIcon-root,
  .page-title {
    color: #fff;
  }

  .page-title {
    margin-left: 1vw;
  }

  .header-left-side {
    display: flex;
    align-items: center;
    flex-basis: 90%;
  }

  .search-button {
    flex-basis: 10%;
    justify-content: end;
    -webkit-justify-content: flex-end;
  }

  .search-input input {
    color: #fff;
  }

  .search-input .search-field::before,
  .search-input .search-field::after {
    display: none;
  }

  .location {
    display: flex;
    align-items: center;
    padding: 1.2vw 0;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 3;
    align-items: flex-end;
  }

  .venue-title {
    font-weight: 500;
    font-size: 34px;
    line-height: 36px;
    letter-spacing: 0.15px;
  }

  .venue-subtitle {
    font-weight: 400;
    font-size: 16px;
    margin-left: 10px;
    color: #979797;
    letter-spacing: 0.15px;
  }

  .venues {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .venue-wrapper {
    border-bottom: 1px solid #00000033;
    margin-bottom: 1.7vw;
    padding-bottom: 1.7vw;
    margin: 0 auto;
    max-width: 1024px;
  }

  .no-results {
    margin: 0 auto;
    max-width: 1024px;
    text-align: center;
    padding-top: 5vmin;
  }

  @media only screen and (max-width: 600px) {
    .venue-title {
      font-size: 20px;
    }

    .venue-subtitle {
      font-size: 12px;
      margin-bottom: 6px;
    }

    .header {
      padding: 0 16px;
    }

    .search-button {
      padding-right: 0;
    }
  }

  @media only screen and (min-width: 601px) and (max-width: 1024px) {
    .venue-title {
      font-size: 24px;
    }

    .venue-subtitle {
      font-size: 14px;
      margin-bottom: 4px;
    }

    .venues.more-than-1 {
      justify-content: center;
    }

    .venues.more-than-1 .brand-venue:nth-last-child(-n + 1) {
      margin-right: auto;
    }

    .venues.more-than-1 .brand-venue:nth-child(even) {
      margin-right: 0;
    }

    .header {
      padding: 0 16px;
    }

    .search-button {
      padding-right: 0;
    }
  }
`;
const BrandVenue = styled_components_1.default.div `
  background-image: ${(props) => `url(${props.image} )`};
  background-size: cover;
  position: relative;
  cursor: pointer;
  height: 200px;
  flex: 0 0 32.5%;
  margin-bottom: 13px;
  color: #fff;

  &:nth-child(3n + 2) {
    margin: 0 12px;
  }

  &:before {
    content: "";
    background: linear-gradient(to bottom, #0000008c, #00000000);
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .venue-details {
    position: relative;
    z-index: 2;
    padding: 12px 7px;
  }

  .venue-name {
    font-weight: 500;
    font-size: 26px;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin-bottom: 5px;
  }

  .venue-location {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.15px;
  }

  @media only screen and (max-width: 1024px) {
    .venue-name {
      font-size: 20px;
      margin-bottom: 4px;
    }

    .venue-location {
      font-size: 16px;
    }
  }

  @media only screen and (max-width: 600px) {
    flex: 1 0 100%;

    &:nth-child(3n + 2) {
      margin: 0 0 13px;
    }
  }

  @media only screen and (min-width: 601px) and (max-width: 1024px) {
    flex: 0 0 48%;

    &:nth-child(3n + 2) {
      margin: 0;
    }

    &:nth-child(even) {
      margin: 0 0 12px 12px;
    }

    &:last-child {
      margin-left: 10px;
    }
  }
`;
const LoaderWrapper = styled_components_1.default.div `
  position: relative;
  height: 100px;
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const BrandVenues = (props) => {
    const { appData, userBrowserLanguage, userData, tileTitle } = props;
    const [initialResults, setInitialResults] = (0, react_1.useState)();
    const [venues, setVenues] = (0, react_1.useState)([]);
    const [query, setQuery] = (0, react_1.useState)("");
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const [showVenueClosedNotice, setShowVenueClosedNotice] = (0, react_1.useState)(false);
    const [isVisibleSearch, setIsVisibleSearch] = (0, react_1.useState)(false);
    const geoLocationOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
    };
    let headerTitle = tileTitle;
    if (tileTitle || typeof tileTitle === "undefined" || tileTitle == null) {
        headerTitle = i18n_js_1.default.t("participating_hotels");
    }
    else if (appData.brandSlug === "sc-reichersbeuern" ||
        appData.brandSlug === "tui-magic-life" ||
        appData.brandSlug === "robinson-club") {
        headerTitle = i18n_js_1.default.t("participating_clubs");
    }
    const getVenueList = (latitude, longitude) => services_1.apiService.getVenuesByCountry(latitude, longitude, appData.brandId, userBrowserLanguage);
    (0, react_1.useEffect)(() => {
        let isSubscribed = true;
        const fetchVenues = (_a) => __awaiter(void 0, [_a], void 0, function* ({ skipGeolocation }) {
            if (skipGeolocation) {
                const venueList = yield getVenueList(0, 0);
                if (isSubscribed) {
                    setInitialResults(venueList);
                    setVenues(venueList);
                    setIsLoaded(true);
                }
                return;
            }
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((location) => __awaiter(void 0, void 0, void 0, function* () {
                    const { latitude } = location.coords;
                    const { longitude } = location.coords;
                    const venueList = yield getVenueList(latitude, longitude);
                    if (isSubscribed) {
                        setInitialResults(venueList);
                        setVenues(venueList);
                        setIsLoaded(true);
                    }
                }), () => __awaiter(void 0, void 0, void 0, function* () {
                    const venueList = yield getVenueList(0, 0);
                    if (isSubscribed) {
                        setInitialResults(venueList);
                        setVenues(venueList);
                        setIsLoaded(true);
                    }
                }), geoLocationOptions);
            }
        });
        // HM-4639: removed location pop-up for bachmair brand
        if (window.location.href.includes("bachmair")) {
            fetchVenues({ skipGeolocation: true });
        }
        else {
            fetchVenues({ skipGeolocation: false });
        }
        // eslint-disable-next-line no-return-assign
        return () => {
            isSubscribed = false;
        };
    }, []);
    const checkinUser = (venue) => __awaiter(void 0, void 0, void 0, function* () {
        if (venue.customOptions) {
            if (venue.customOptions.venueClosed) {
                setShowVenueClosedNotice(true);
                return false;
            }
        }
        const checkin = yield services_1.apiService.checkinUser(venue.defaultLocale, userData.token, venue.id);
        if (checkin.status === "success") {
            return props.history.push({
                pathname: `/${venue.slug}`,
            });
        }
        return false;
    });
    const handleVenueSearch = (event) => {
        const searchText = event.target.value.toLowerCase();
        setQuery(searchText);
        if (initialResults) {
            const venuesFilter = initialResults
                .filter((country) => country.venues.filter((item) => item.title.toLowerCase().includes(searchText)).length > 0)
                .map((country) => (Object.assign(Object.assign({}, country), { venues: country.venues.filter((item) => item.title.toLowerCase().includes(searchText)) })));
            setVenues(venuesFilter);
        }
    };
    const toggleSearchInput = () => {
        setIsVisibleSearch(!isVisibleSearch);
        setQuery("");
        setVenues(initialResults);
    };
    const renderVenues = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Box, { className: "header" },
            isVisibleSearch === false ? (react_1.default.createElement(material_1.Box, { className: "header-left-side" },
                appData.showBrandInfo === true && react_1.default.createElement(BackButton_1.default, null),
                react_1.default.createElement(material_1.Typography, { className: "page-title" },
                    " ",
                    headerTitle,
                    " "))) : (react_1.default.createElement(material_1.FormControl, { fullWidth: true, variant: "standard", className: "search-input" },
                react_1.default.createElement(material_1.Input, { id: "search", className: "search-field", value: query, placeholder: i18n_js_1.default.t("hotel_list_app_bar_search_on"), onChange: handleVenueSearch, autoFocus: true }))),
            isVisibleSearch === false ? (react_1.default.createElement(material_1.IconButton, { "aria-label": "search", color: "inherit", className: "search-button", onClick: () => toggleSearchInput() },
                react_1.default.createElement(Search_1.default, null))) : (react_1.default.createElement(material_1.IconButton, { "aria-label": "search", color: "inherit", className: "close-button", onClick: () => toggleSearchInput() },
                react_1.default.createElement(Close_1.default, null)))),
        isLoaded ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Box, { className: "no-results" }, venues && venues.length === 0 && (react_1.default.createElement(material_1.Typography, null,
                " ",
                i18n_js_1.default.t("no_results"),
                " "))),
            venues && venues.length > 0 &&
                venues.map((item) => (react_1.default.createElement(material_1.Box, { className: "venue-wrapper", key: (0, react_uid_1.uid)(item) },
                    react_1.default.createElement(material_1.Box, { className: "location" },
                        react_1.default.createElement(material_1.Typography, { className: "venue-title" }, item.title === "Nearby" ? i18n_js_1.default.t("nearby") : item.title),
                        react_1.default.createElement(material_1.Typography, { className: "venue-subtitle" }, item.venues.length === 1
                            ? `${item.venues.length} ${i18n_js_1.default.t("parameter_hotel_type")}`
                            : `${item.venues.length} ${i18n_js_1.default.t("parameter_hotels_type")}`)),
                    react_1.default.createElement(material_1.Box, { className: `venues ${item.venues.length > 1 ? "more-than-1" : ""}` }, item &&
                        item.venues.map((venue) => {
                            const venueImage = venue.icon ? venue.icon["2:1"].L : "";
                            return (react_1.default.createElement(BrandVenue, { image: venueImage, key: (0, react_uid_1.uid)(venue), onClick: () => checkinUser(venue), className: "brand-venue" },
                                react_1.default.createElement(material_1.Box, { className: "venue-details" },
                                    react_1.default.createElement(material_1.Typography, { className: "venue-name" },
                                        " ",
                                        venue.title,
                                        " "),
                                    venue.locality && (react_1.default.createElement(material_1.Typography, { className: "venue-location" },
                                        " ",
                                        venue.locality,
                                        " ")))));
                        }))))))) : (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(LoaderWrapper, null,
                react_1.default.createElement(Loader_1.default, null))))));
    return (react_1.default.createElement(BrandVenuesWrapper, null,
        react_1.default.createElement(material_1.Box, null, renderVenues()),
        react_1.default.createElement(material_1.Dialog, { open: showVenueClosedNotice, TransitionComponent: Transition, keepMounted: true, onClose: () => setShowVenueClosedNotice(false), "aria-describedby": "alert-dialog-slide-description" },
            react_1.default.createElement(material_1.DialogTitle, null, "Notice"),
            react_1.default.createElement(material_1.DialogContent, null, "Hotel currently not open. Please check back later."),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => setShowVenueClosedNotice(false) }, "Ok")))));
};
const mapStoreToProps = (store) => ({
    appData: store.getValue("appData"),
    userData: store.getValue("userData"),
    userBrowserLanguage: store.getValue("userBrowserLanguage"),
    tileTitle: store.getValue("tileTitle"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(BrandVenues));
